import React from 'react'
import { Collapse } from 'components/common/Collapse'
import { FlexColumn, FlexRow } from 'components/common/Containers'
import Input from 'components/common/Input/Input'
import { Slider } from 'components/common/Slider'
import { domainMaxLength, domainMinLength } from 'constants/domainLength'
import styles from '../index.module.scss'

interface Props {
  values: number[]
  onMinChange: (value: number) => void
  onMaxChange: (value: number) => void
}

const LengthFilter: React.FC<Props> = ({
  values,
  onMinChange,
  onMaxChange,
}) => {
  return (
    <Collapse
      gap="20px"
      header={<h6 className={styles.filterTitle}>Length</h6>}
      hasArrow
      defaultOpen
    >
      <FlexColumn gap="18px" align="normal">
        <FlexRow gap="7.5px" align="center" justify="space-between">
          <Input
            type="number"
            value={values[0]}
            onChange={(e) => {
              onMinChange(parseInt(e.target.value))
            }}
            isFormik={false}
          />
          <span>to</span>
          <Input
            type="number"
            value={values[1]}
            onChange={(e) => {
              onMaxChange(parseInt(e.target.value))
            }}
            isFormik={false}
          />
        </FlexRow>

        <Slider.Range
          minValue={domainMinLength}
          maxValue={domainMaxLength}
          value={{
            min: values[0],
            max: values[1],
          }}
          onChange={(values) => {
            onMinChange(values.min)
            onMaxChange(values.max)
          }}
        />
      </FlexColumn>
    </Collapse>
  )
}

export default LengthFilter
